import React, { useEffect, useState } from "react";
import { Container, Typography, Button, Card, CardContent, Grid2, Box, List, ListItem, ListItemIcon, ListItemText, Stack } from "@mui/material";
import { Backdrop, CircularProgress } from "@mui/material";
import { Star, CheckCircle } from "@mui/icons-material";
import { motion } from "framer-motion";
import DiamondIcon from '@mui/icons-material/Diamond';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import ImageModal from "./ImageModal";
const live_events_service = require('../../helpers/live_events_service')

const sponsorshipLevels = [
    { level: "Diamante", price: "$3,900", benefits: ["Logotipo en la página del evento", "Video exclusivo del conferencista", "Promoción digital", "Email marketing", "1 Speaker en el programa académico", "Presencia de marca en material promocional"] },
    { level: "Oro", price: "$3,000", benefits: ["Logotipo en la página del evento", "Promoción digital", "Email marketing", "Presencia de marca en material promocional", "Stand en el área de exposición"] },
    { level: "Plata", price: "$2,500", benefits: ["Logotipo en la página del evento", "Promoción digital", "Email marketing", "Presencia de marca en material promocional"] }
];

export default function Patrocinio() {
    const [evento, setEvento] = useState(null);
    const [loading, setLoading] = useState(true);
    const [contador] = useState(0)
    useEffect(() => {
        live_events_service.getData('/evento/view-by-hash/' + process.env.REACT_APP_EVT).then((response) => {
            setEvento(response.data.response_database.result[0])
            setLoading(false)
        }).catch((error) => {
            console.log(error)
        })
    }, [contador])
    return (
        <Container maxWidth style={{ backgroundColor: '#215d41', color: '#abcac2', padding: '20px', textAlign: 'center' }}>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <motion.div initial={{ opacity: 0, y: -50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
                <Typography variant="h3" gutterBottom>
                    COREFIS 2025 - Patrocinios
                </Typography>
                <Typography variant="h6" paragraph>
                    Únete como patrocinador de COREFIS 2025 y obtén visibilidad en uno de los eventos más importantes en seguridad financiera.
                </Typography>
            </motion.div>

            <Grid2 container spacing={3} justifyContent="center">
                {sponsorshipLevels.map((sponsor, index) => (
                    <Grid2 key={index} xs={12} md={6} lg={4} display="flex">
                        <motion.div whileHover={{ scale: 1.05 }} style={{ width: '100%', height: '100%' }}>
                            <Card style={{
                                backgroundColor: '#abcac2',
                                color: '#215d41',
                                borderRadius: '15px',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%'  // Ajuste clave aquí
                            }}>
                                <CardContent style={{ flexGrow: 1 }}>
                                    <Typography variant="h3" gutterBottom>
                                        {sponsor.level}
                                    </Typography>
                                    <List>
                                        {sponsor.benefits.map((benefit, i) => (
                                            <ListItem key={i} >
                                                <ListItemIcon>
                                                    <CheckCircle style={{ color: '#215d41' }} />
                                                </ListItemIcon>
                                                <ListItemText primary={<Typography style={{ fontSize: '1.3em' }}>
                                                    {benefit}
                                                </Typography>} />
                                            </ListItem>
                                        ))}
                                    </List>
                                </CardContent>
                            </Card>
                        </motion.div>
                    </Grid2>
                ))}
            </Grid2>

            <motion.div whileHover={{ scale: 1.1 }} style={{ marginTop: '20px' }}>
                <Button variant="contained" style={{ backgroundColor: '#abcac2', color: '#215d41', fontWeight: 'bold' }} href="mailto:ncuches@ebg.edu.gt?subject=Solicitud%20de%20información%20sobre%20patrocinio%20para%20COREFIS&body=Buenos%20días,%0A%0ANecesito%20más%20información%20sobre%20una%20propuesta%20de%20patrocinio%20para%20COREFIS.%0A%0AGracias." target="_blank">
                    Click para solicitar más información
                </Button>
            </motion.div>

            <Grid2 container alignItems='center' mt={5}>
                <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                    <video playsInline autoPlay controls style={{ width: "75%" }}>
                        <source
                            src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/8fa94c32-0ac9-4c02-9bea-9efac1bd5343.mp4"
                            type="video/mp4"
                        />
                    </video>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 12, lg: 6 }}>
                    <Stack spacing={5}>
                        <Typography variant="h3">Planos de evento</Typography>
                        {evento && <ImageModal src={evento.planos} alt='planos' />}
                    </Stack>
                </Grid2>
            </Grid2>

        </Container>
    );
}
